export const SET_MOBILE_MODE = 'SET_MOBILE_MODE';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';